export const LOAD_FOTOS_VISTORIA = 'LOAD_FOTOS_VISTORIA';
export const GET_FOTOS_VISTORIA = 'GET_FOTOS_VISTORIA';
export const STORE_FOTO_VISTORIA = 'STORE_FOTO_VISTORIA';
export const GET_FOTO_VISTORIA = 'GET_FOTO_VISTORIA';
export const REMOVE_FOTO_VISTORIA = 'REMOVE_FOTO_VISTORIA';
export const CHANGE_STATUS_CODE = 'CHANGE_STATUS_CODE';
export const FOTO_VISTORIA_ERROR = 'FOTO_VISTORIA_ERROR';
